module.exports = __webpack_public_path__ + "assets/notification-green.fa30f57e.svg";